module.exports = __webpack_public_path__ + "@/assets/img/examenes2B2020R20.03ce2710.png";